import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import carimg2 from "../../ulits/images/car_img2.png";
import { useDispatch, useSelector } from "react-redux";
import { sellCarAction } from "../../_actions/sellCar.action";
import { configes } from "../../webData";
import { useNavigate } from "react-router";
import { configs } from "../../config";
// import arrowicon from "../../ulits/images/arrow_icon.svg";

function Sell() {
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || []; const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const config = localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    addressLine2: "",
    sellerPersonalCity: "",
    state: "",
    sellerPersonalPostalCode: "",
    sellerPersonalCountry: "",
    company: "",
    model: "",
    transmission: "",
    sellerCarCountry: "",
    year: "",
    vin: "",
    sellerCarCity: "",
    sellerCarPostalCode: "",
    mileage: "",
    image: "",
    exteriorColor: "",
    interiorColor: "",
    owner: "",
    exteriorCondition: "",
    interiorCondition: "",
    hasVahicalAccidented: "",
    expectedPrice: "",
    message: "",
    tenantId: configes.domainId,
  });

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10,12}$/.test(formData.phone)) {
      newErrors.phone = "Phone number should be 10-12 digits";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }

    if (!formData.addressLine2.trim()) {
      newErrors.addressLine2 = "Address is required";
    }

    if (!formData.state.trim()) {
      newErrors.state = "State is required";
    }

    if (!formData.sellerPersonalCity.trim()) {
      newErrors.sellerPersonalCity = "City is required";
    }

    if (!formData.sellerPersonalPostalCode.trim()) {
      newErrors.sellerPersonalPostalCode = "Postal code is required";
    }

    if (!formData.sellerPersonalCountry.trim()) {
      newErrors.sellerPersonalCountry = "Country is required";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Make is required";
    }

    if (!formData.model.trim()) {
      newErrors.model = "Model is required";
    }

    if (
      !formData.transmission.trim() ||
      formData.transmission === "Transmission"
    ) {
      newErrors.transmission = "Transmission is required";
    }

    if (!formData.year.trim()) {
      newErrors.year = "Year is required";
    } else if (!/^\d{4}$/.test(formData.year)) {
      newErrors.year = "Enter valid 4-digit year";
    }

    if (!formData.vin.trim()) {
      newErrors.vin = "VIN is required";
    }

    if (!formData.sellerCarCity.trim()) {
      newErrors.sellerCarCity = "City is required";
    }

    if (!formData.sellerCarPostalCode.trim()) {
      newErrors.sellerCarPostalCode = "Postal code is required";
    }

    if (!formData.mileage.trim()) {
      newErrors.mileage = "Mileage is required";
    }

    if (!formData.sellerCarCountry.trim()) {
      newErrors.sellerCarCountry = "Country is required";
    }

    if (!formData.exteriorColor.trim()) {
      newErrors.exteriorColor = "Exterior Color is required";
    }
    if (!formData.interiorColor.trim()) {
      newErrors.interiorColor = "Interior Color is required";
    }
    if (!formData.owner.trim()) {
      newErrors.owner = "Owner is required";
    }
    if (!formData.exteriorCondition.trim()) {
      newErrors.exteriorCondition = "Exterior Condition is required";
    }
    if (!formData.interiorCondition.trim()) {
      newErrors.interiorCondition = "Interior Condition is required";
    }
    if (!formData.hasVahicalAccidented.trim()) {
      newErrors.hasVahicalAccidented =
        "Choose any value of vahical accidented.";
    }

    if (!formData.mileage.trim()) {
      newErrors.mileage = "Mileage is required";
    }

    if (!formData.expectedPrice.trim()) {
      newErrors.expectedPrice = "Expected price is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Field: ${name}, Value: ${value}`);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const data = new FormData();
    data.append("tenantId", configes.domainId);
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("address", formData.address);
    data.append("addressLine2", formData.addressLine2);
    data.append("sellerPersonalCity", formData.sellerPersonalCity);
    data.append("state", formData.state);
    data.append("sellerPersonalPostalCode", formData.sellerPersonalPostalCode);
    data.append("sellerPersonalCountry", formData.sellerPersonalCountry);
    data.append("company", formData.company);
    data.append("model", formData.model);
    data.append("transmission", formData.transmission);
    data.append("sellerCarCountry", formData.sellerCarCountry);
    data.append("year", formData.year);
    data.append("vin", formData.vin);
    data.append("sellerCarCity", formData.sellerCarCity);
    data.append("sellerCarPostalCode", formData.sellerCarPostalCode);
    data.append("mileage", formData.mileage);
    if (formData.image && formData.image instanceof File) {
      data.append("image", formData.image);
    }
    data.append("exteriorColor", formData.exteriorColor);
    data.append("interiorColor", formData.interiorColor);
    data.append("owner", formData.owner);
    data.append("exteriorCondition", formData.exteriorCondition);
    data.append("interiorCondition", formData.interiorCondition);
    data.append("hasVahicalAccidented", formData.hasVahicalAccidented === "true");
    data.append("expectedPrice", formData.expectedPrice);
    data.append("message", formData.message);

    // for (let [key, value] of data.entries()) {
    //   console.log(key + ": " + value);
    // }

    dispatch(sellCarAction.sellCar(data));
    navigate("/");
    setFormData({
      name: "",
      email: "",
      phone: "",
      address: "",
      addressLine2: "",
      sellerPersonalCity: "",
      state: "",
      sellerPersonalPostalCode: "",
      sellerPersonalCountry: "",
      company: "",
      model: "",
      transmission: "",
      sellerCarCountry: "",
      year: "",
      vin: "",
      sellerCarCity: "",
      sellerCarPostalCode: "",
      mileage: "",
      image: null,
      exteriorColor: "",
      interiorColor: "",
      owner: "",
      exteriorCondition: "",
      interiorCondition: "",
      hasVahicalAccidented: "",
      expectedPrice: "",
      message: "",
    });
  };

  return (
    <div className="main-wrapper">
      <div className="sell-section">
        <div className="container">
          <div className="stm-breadcrumbs">
            <img src={`${configs.localApiUrl}${config?.Sell_car_image}`} alt="" />
          </div>
          <div className="stm-breadcrumbs-title">
            <h1>SELL YOUR LEFT HAND DRIVE CAR</h1>
          </div>
          <div className="stm-sell-form">
            <section className="group-section">
              <h2>Personal Details</h2>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="NAME"
                  id="name"
                  name="name"
                  type="text"
                  onChange={handleChange}
                  value={formData.name}
                />
                {errors.name && <div className="erro-style">{errors.name}</div>}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="EMAIL"
                  id="email"
                  name="email"
                  type="email"
                  onChange={handleChange}
                  value={formData.email}
                />
                {errors.email && (
                  <div className="erro-style">{errors.email}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="PHONE"
                  id="phone"
                  name="phone"
                  type="text"
                  onChange={handleChange}
                  value={formData.phone}
                />
                {errors.phone && (
                  <div className="erro-style">{errors.phone}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="ADDRESS"
                  id="address"
                  name="address"
                  type="text"
                  onChange={handleChange}
                  value={formData.address}
                />
                {errors.address && (
                  <div className="erro-style">{errors.address}</div>
                )}
              </div>
              <div className="form-group">
                <div className="col-span-2">
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="ADDRESS LINE 2"
                      id="addressLine2"
                      name="addressLine2"
                      type="text"
                      onChange={handleChange}
                      value={formData.addressLine2}
                    />
                    {errors.addressLine2 && (
                      <div className="erro-style">{errors.addressLine2}</div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="STATE/PROVINCE/REGION"
                      id="state"
                      name="state"
                      type="text"
                      onChange={handleChange}
                      value={formData.state}
                    />
                    {errors.state && (
                      <div className="erro-style">{errors.state}</div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="CITY"
                      id="sellerPersonalCity"
                      name="sellerPersonalCity"
                      type="text"
                      onChange={handleChange}
                      value={formData.sellerPersonalCity}
                    />
                    {errors.sellerPersonalCity && (
                      <div className="erro-style">
                        {errors.sellerPersonalCity}
                      </div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="POSTAL CODE"
                      id="sellerPersonalPostalCode"
                      name="sellerPersonalPostalCode"
                      type="text"
                      onChange={handleChange}
                      value={formData.sellerPersonalPostalCode}
                    />
                    {errors.sellerPersonalPostalCode && (
                      <div className="erro-style">
                        {errors.sellerPersonalPostalCode}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="COUNTRY"
                  id="sellerPersonalCountry"
                  name="sellerPersonalCountry"
                  type="text"
                  onChange={handleChange}
                  value={formData.sellerPersonalCountry}
                />
                {errors.sellerPersonalCountry && (
                  <div className="erro-style">
                    {errors.sellerPersonalCountry}
                  </div>
                )}
              </div>
            </section>
            <section className="group-section">
              <h2>Car Details</h2>
              <div className="form-group ">
                <input
                  className="form-control"
                  placeholder="MAKE"
                  id="company"
                  name="company"
                  type="text"
                  onChange={handleChange}
                  value={formData.company}
                />
                {errors.company && (
                  <div className="erro-style">{errors.company}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="MODEL"
                  id="model"
                  name="model"
                  type="text"
                  onChange={handleChange}
                  value={formData.model}
                />
                {errors.model && (
                  <div className="erro-style">{errors.model}</div>
                )}
              </div>
              <div className="form-group">
                <div className="custom-select-wrapper">
                  <select
                    className="form-control"
                    name="transmission"
                    type="text"
                    onChange={handleChange}
                    value={formData.transmission}
                  >
                    <option>TRANSMISSION</option>
                    <option>Automatic</option>
                    <option>Semi-Automatic</option>
                    <option>Manual</option>
                  </select>
                </div>
                {errors.transmission && (
                  <div className="erro-style">{errors.transmission}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="COUNTRY"
                  id="sellerCarCountry"
                  name="sellerCarCountry"
                  type="text"
                  onChange={handleChange}
                  value={formData.sellerCarCountry}
                />
                {errors.sellerCarCountry && (
                  <div className="erro-style">{errors.sellerCarCountry}</div>
                )}
              </div>
              <div className="form-group">
                <div className="col-span-2">
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="YEAR"
                      id="year"
                      name="year"
                      type="text"
                      onChange={handleChange}
                      value={formData.year}
                    />
                    {errors.year && (
                      <div className="erro-style">{errors.year}</div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="VIN"
                      id="vin"
                      name="vin"
                      type="text"
                      onChange={handleChange}
                      value={formData.vin}
                    />
                    {errors.vin && (
                      <div className="erro-style">{errors.vin}</div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="CITY"
                      id="sellerCarCity"
                      name="sellerCarCity"
                      type="text"
                      onChange={handleChange}
                      value={formData.sellerCarCity}
                    />
                    {errors.sellerCarCity && (
                      <div className="erro-style">{errors.sellerCarCity}</div>
                    )}
                  </div>
                  <div className="form-groups">
                    <input
                      className="form-control"
                      placeholder="POSTAL CODE"
                      id="sellerCarPostalCode"
                      name="sellerCarPostalCode"
                      type="text"
                      onChange={handleChange}
                      value={formData.sellerCarPostalCode}
                    />
                    {errors.sellerCarPostalCode && (
                      <div className="erro-style">
                        {errors.sellerCarPostalCode}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="MILEAGE"
                  id="mileage"
                  name="mileage"
                  type="text"
                  onChange={handleChange}
                  value={formData.mileage}
                />
                {errors.mileage && (
                  <div className="erro-style">{errors.mileage}</div>
                )}
              </div>
            </section>
            <section className="group-section">
              <h2>Upload Image (Optional)</h2>
              <div className="form-group">
                <input
                  type="file"
                  accept="image/*"
                  name="image"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      image: e.target.files[0],
                    }))
                  }
                />
              </div>
            </section>

            <section className="group-section">
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="EXTERIOR COLOR"
                  id="exteriorColor"
                  name="exteriorColor"
                  type="text"
                  onChange={handleChange}
                  value={formData.exteriorColor}
                />
                {errors.exteriorColor && (
                  <div className="erro-style">{errors.exteriorColor}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="INTERIOR COLOR"
                  id="interiorColor"
                  name="interiorColor"
                  type="text"
                  onChange={handleChange}
                  value={formData.interiorColor}
                />
                {errors.interiorColor && (
                  <div className="erro-style">{errors.interiorColor}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="OWNER"
                  id="owner"
                  name="owner"
                  type="text"
                  onChange={handleChange}
                  value={formData.owner}
                />
                {errors.owner && (
                  <div className="erro-style">{errors.owner}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="EXTERIOR CONDITION"
                  id="exteriorCondition"
                  name="exteriorCondition"
                  type="text"
                  onChange={handleChange}
                  value={formData.exteriorCondition}
                />
                {errors.exteriorCondition && (
                  <div className="erro-style">{errors.exteriorCondition}</div>
                )}
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="INTERIOR CONDITION"
                  id="interiorCondition"
                  name="interiorCondition"
                  type="text"
                  onChange={handleChange}
                  value={formData.interiorCondition}
                />
                {errors.interiorCondition && (
                  <div className="erro-style">{errors.interiorCondition}</div>
                )}
              </div>

              <div className="form-group">
                <div className="custom-select-wrapper">
                  <select
                    className="form-control"
                    name="hasVahicalAccidented"
                    type="text"
                    onChange={handleChange}
                    value={formData.hasVahicalAccidented}
                  >
                    <option value="">VAHICAL ACCIDENTTED</option>
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </div>
                {errors.hasVahicalAccidented && (
                  <div className="erro-style">
                    {errors.hasVahicalAccidented}
                  </div>
                )}
              </div>

              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="YOUR EXPECTED PRICE"
                  id="expectedPrice"
                  name="expectedPrice"
                  type="text"
                  onChange={handleChange}
                  value={formData.expectedPrice}
                />
                {errors.expectedPrice && (
                  <div className="erro-style">{errors.expectedPrice}</div>
                )}
              </div>
              <div className="form-group">
                <textarea
                  placeholder="COMMENT OR MESSAGE"
                  rows={5}
                  className="textarea"
                  id="message"
                  name="message"
                  type="text"
                  onChange={handleChange}
                  value={formData.message}
                />
                {errors.message && (
                  <div className="erro-style">{errors.message}</div>
                )}
              </div>
            </section>
            <button
              type="submit"
              className="stm-btn-primary"
              onClick={handleSubmit}
            >
              SUBMIT
              <div className="arrow-icons" />
            </button>
          </div>
        </div>
      </div>
      <div className="stm-accordion-single-unit">
        <div className="container">
          <div className="stm-accordion-title">
            <h3>FREQUENTLY ASKED QUESTIONS</h3>
          </div>
          {faqList.length > 0 &&
            faqList.map((item, index) => (
              <Accordion key={index}>
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header>{item.que}</Accordion.Header>
                  <Accordion.Body>{item.ans}</Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Sell;
